export default __webpack_public_path__ + "static/media/Maduro-2.9988e12a.png";